// Collection-page + brand-index UX behaviors.
// Extracted 2026-05-13 from product-ux.js so collection / search / brand pages
// don't pay for PDP-only code (slider, countdown, accordion, sticky-cart).
//
// Both blocks below use event delegation — one document-level click listener,
// no per-element addEventListener at boot, works on AJAX-injected card variants
// added by Shopify's facet filter after page load.
(function () {
  'use strict';

  function init() {
    document.addEventListener('click', (e) => {
      // ---- Brand A-Z smooth-scroll ---------------------------------------
      // Letters in `.brand-wrapper-letter span` carry an aria-label that's the
      // ID of the section to scroll to.
      const letter = e.target.closest('.brand-wrapper-letter span');
      if (letter) {
        const targetId = letter.getAttribute('aria-label');
        if (!targetId) return;
        const target = document.getElementById(targetId);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      // ---- Collection-card variant pill swatch ---------------------------
      // Clicking a chip swaps the card's price + compare-price + discount %
      // + the sticky-add-to-cart total (if present) to the chip's variant.
      const variant = e.target.closest('.pb-variant-options .variant');
      if (!variant) return;

      const info = variant.closest('.card__information');
      const card = variant.closest('.card-wrapper');
      if (!info) return;

      requestAnimationFrame(() => {
        info.querySelectorAll('.variant').forEach((v) => v.classList.remove('active'));
        variant.classList.add('active');

        const id = variant.getAttribute('id');
        const price = variant.getAttribute('money-value');
        const offerPrice = variant.getAttribute('offer-money');
        const compare = variant.getAttribute('com-money-value');

        if (id) {
          const idInput = info.querySelector('input.product-variant-id');
          if (idInput) idInput.value = id;
        }
        if (price) {
          info.querySelectorAll('span.price-item.price-item--sale, .cartprice')
            .forEach((el) => { el.textContent = price; });
        }
        if (offerPrice) {
          const stickyB = document.querySelector('.sticky-add-to-cart-bs .sticky-cart-top b');
          if (stickyB) stickyB.textContent = offerPrice;
        }
        if (compare) {
          info.querySelectorAll('s.price-item.price-item--regular')
            .forEach((el) => { el.textContent = compare; });
          if (price && card) {
            const compareNum = parseFloat(compare.replace(/[₹,]/g, ''));
            const priceNum = parseFloat(price.replace(/[₹,]/g, ''));
            if (compareNum > priceNum && compareNum > 0) {
              const discount = Math.round(((compareNum - priceNum) / compareNum) * 100);
              const discountEl = card.querySelector('.pb-discount');
              if (discountEl) discountEl.textContent = discount + '% OFF';
            }
          }
        }
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
